// extracted by mini-css-extract-plugin
module.exports = {"rating-root":"Rating_rating-root__1TT6R","xs":"Rating_xs__Gh5gM","sm":"Rating_sm__3zCjr","base":"Rating_base__At-1J","md":"Rating_md__1bxwG"};